export type RewardsSection = 'overview' | 'missions' | 'mission' | 'activity' | 'levels' | 'rules' | 'reviews' | 'profile' | 'invite' | 'notifications' | 'delete'
interface RewardsLocation {
  section: RewardsSection
  params: Record<string, string>
}
/** Navigation belongs to the drawer, so Back never loses the underlying shop page. */
export function useRewardsDrawer() {
  const visible = useState('rewards-drawer-open', () => false)
  const wanted = useState('rewards-drawer-wanted', () => false)
  const history = useState<RewardsLocation[]>('rewards-drawer-history', () => [{ section: 'overview', params: {} }])
  const drawers = useDrawers()
  const location = computed(() => history.value.at(-1)!)
  function open(section: RewardsSection = 'overview', params: Record<string, string> = {}) {
    drawers.value.cart.open = false
    drawers.value.navigation.open = false
    history.value = [{ section, params }]
    wanted.value = true
    visible.value = true
  }
  function navigate(section: RewardsSection, params: Record<string, string> = {}) {
    if (location.value.section === section && JSON.stringify(location.value.params) === JSON.stringify(params))
      return
    history.value.push({ section, params })
  }
  function back() {
    if (history.value.length > 1)
      history.value.pop()
    else if (location.value.section !== 'overview')
      history.value = [{ section: 'overview', params: {} }]
    else
      visible.value = false
  }
  function close() {
    visible.value = false
  }
  function reset() {
    close()
    history.value = [{ section: 'overview', params: {} }]
  }
  return { visible, wanted, section: computed(() => location.value.section), params: computed(() => location.value.params), open, navigate, back, close, reset }
}
